<script>
import BaseMenu from '../common/BaseMenu';
import { menuItems } from './router';
import { configAccess } from '@/lib/functional';

export default {
    name: 'BaseSale',
    extends: BaseMenu,
    data () {
        return {
            navMenus: {
                defaultActive: '/outActiveDetail',
                menuItems: [menuItems],
            },
            site: '网页管理',
            loading: '',
            include: [],
        };
    },
    computed: {
        cp_org_id () {
            return this.$store.getters['global/orgId'];
        },
        cp_accessCode () {
            return this.$store.getters['system/access'];
        },
    },
    watch: {
        cp_accessCode: {
            immediate: true,
            deep: true,
            handler (code) {
                let self = this;
                self.navMenus.menuItems = configAccess(menuItems, code || [], {
                    orgId: self.cp_org_id,
                    orgType: self.$store.getters['global/currentOrg'].orgType,
                    identityId: self.$store.getters['global/userIdentity'],
                }, 'menu');
            },
        },
    },
    beforeRouteEnter (to, from, next) {
        to.matched.some(itm => {
            if (itm.meta.documentTitle) {
                document.title = itm.meta.documentTitle;
                return true;
            }
        });
        next();
    },
};
</script>

<style lang="scss">
.menu-icon {
    display: inline-block;
    width: 20px;
    height: 20px;
    vertical-align: middle;
}
.icon-site {
    background: url('../../assets/icon/ic_site_grey.png') no-repeat center;
}
.icon-tpl {
    background: url('../../assets/icon/ic_tpl_grey.png') no-repeat center;
}
.icon-auth {
    background: url('../../assets/image/icon_form_jurisdiction_grey.png') no-repeat center;
}
.is-active , .is-active > .el-submenu__title {
    & > .icon-site {
        background: url('../../assets/icon/ic_site_green.png') no-repeat center;
    }
    & > .icon-tpl {
        background: url('../../assets/icon/ic_tpl_green.png') no-repeat center;
    }
    & > .icon-auth {
        background: url('../../assets/image/icon_form_jurisdiction_green.png') no-repeat center;
    }
}
</style>
